module.exports = __webpack_public_path__ + "static/media/logo-top.894142df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-top.png
// module id = 245
// module chunks = 0